import { render } from "./index-page.vue?vue&type=template&id=fc6e3366&scoped=true"
import script from "./index-page.vue?vue&type=script&lang=js"
export * from "./index-page.vue?vue&type=script&lang=js"

import "./index-page.vue?vue&type=style&index=0&id=fc6e3366&scoped=true&lang=css"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6e3366"]])

export default __exports__